'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.memberStatus = exports.enumMap = undefined;

var _enumHelper = require('./enumHelper');

var enumMap = exports.enumMap = {
  ACTIVE: 'active',
  PENDING: 'pending',
  HOLD: 'hold',
  CANCELLED: 'cancelled',
  UNPAID: 'unpaid',
  UNSUBSCRIBED: 'unsubscribed'
};

var memberStatus = exports.memberStatus = _enumHelper.enumHelper.bind(undefined, 'MemberStatus', enumMap);